import React from 'react';
import Translations from '../../../translation/translation';

function MissingLoadIndex() {
    return (
        <div className="statusbar-mobile__missing-status statusbar-mobile__missing-status--load-index">
            <Translations translationKey="catalog-missing-status-speed-index-hint" />
            {' '}
            <Translations translationKey="catalog-statusbar-mobile-missing-status-load-index" className="statusbar-mobile__missing-status-action-text" />
        </div>
    );
}

export { MissingLoadIndex};
